import axios, {CancelTokenSource, Method} from "axios";
import {Modal} from "./modal";

export class Ajax {
    private process: CancelTokenSource = null;
    private readonly onLoadInitFunction: CallableFunction;
    private previousUrl: string = window.location.href;

    constructor(onLoadInitFunction: CallableFunction) {
        this.onLoadInitFunction = onLoadInitFunction;
    }

    private start(cancel: CancelTokenSource) {
        this.process = cancel;
        document.body.classList.add('loading');
    }

    private end() {
        setTimeout(() => {
            document.body.classList.remove('loading');
            this.previousUrl = window.location.href;
        })
    }

    private cancel() {
        this.process.cancel("internal handler cancel");
        this.process = null;
    }

    public go(
        href: string,
        selectorsList: string,
        method: Method = 'get',
        data: any = [],
        func: (response: Document) => boolean = _ => true
    ) {
        window.history.pushState('', '', href);
        return this.silent(href, selectorsList, method, data, func).then(_ => {
        });
    }

    public silent(
        href: string,
        selectorsList: string,
        method: Method = 'get',
        data: any = [],
        func: (response: Document) => boolean = _ => true
    ) {
        if (this.process !== null) {
            this.cancel();
        }

        const source = axios.CancelToken.source();
        let selectors = selectorsList.split(',');
        selectors.unshift('content-header');
        this.start(source);
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        return axios({
            url: href,
            cancelToken: source.token,
            method,
            data,
            params: data,
        }).then(response => {
            Modal.closeAll();
            const htmlDoc = new DOMParser().parseFromString(response.data, 'text/html');
            if (func(htmlDoc)) {
                selectors.forEach(selector => {
                    let dataSelector = '[data-ajax-container=' + selector + ']';
                    const inputElement = htmlDoc.querySelector(dataSelector) as HTMLElement;
                    const pageElement: HTMLElement = document.querySelector(dataSelector);
                    pageElement.innerHTML = '';
                    pageElement.replaceWith(inputElement);
                });
                document.title = htmlDoc.title;
            }
            this.onLoadInitFunction(document);
            this.cancel();
            this.end();

            return htmlDoc;
        }).catch(error => {
            if (error.message !== 'internal handler cancel') {
                this.cancel();
                this.end();
                document.body.classList.add('loading-error');
                setTimeout(() => {
                    document.body.classList.remove('loading-error');
                }, 3000);
            }
        });
    }
}